import { Component, Input } from '@angular/core'

/**
 * El «?» que explica de dónde sale una cifra.
 *
 * ## Por qué existe siendo tan pequeño
 *
 * Las pantallas de Cobranza enseñan cifras DERIVADAS: la cartera se compone de cuatro cosas, el
 * cobrado sale de dos sitios distintos según el rubro, y la diferencia es una verificación. Nada de
 * eso se adivina mirando el número, y quien no lo sabe concluye que el sistema se equivocó — que es
 * la conversación más cara de todas.
 *
 * El contenido lo proyecta cada pantalla porque **cada cifra se explica distinto**; lo que se
 * comparte es el botón, el panel y su tipografía, para que las tres explicaciones se lean igual.
 *
 * `cobranza-funnel` conserva su propia copia: su panel no es texto sino una tabla de componentes con
 * importes en vivo, y migrarlo sería reescribir la pantalla que el owner ya dio por buena.
 */
@Component({
  selector: 'app-ayuda-cifra',
  templateUrl: './ayuda-cifra.component.html',
  styleUrls: ['./ayuda-cifra.component.scss'],
})
export class AyudaCifraComponent {
  /** Qué se está explicando. Va en el encabezado del panel y en el nombre accesible del botón. */
  @Input() titulo = ''
}
